export default [
  [`Размер`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `46`, `48`, `50`, `52`, `54`, `56`]
];
